import { subCompaniesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const updateSubCompanyBrandingAction = catchAsyncActionError(
  ({ subCompanyId, branding }) =>
    async () => {
      const { data } = await subCompaniesApi.updateSubCompanyBranding({
        id: subCompanyId,
        branding,
      });

      return data;
    },
);

export const uploadSubCompanyImageAction = catchAsyncActionError(
  ({ subCompanyId, type, formData }) =>
    async () => {
      const { data } = await subCompaniesApi.uploadSubCompanyImage({
        id: subCompanyId,
        type,
        formData,
      });

      return data;
    },
);
